import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  quote: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300" data-id="element-199">
      <div className="flex space-x-1 mb-4" data-id="element-200">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-[#FFC107] text-[#FFC107]" data-id="element-201" />)}
      </div>
      <p className="text-gray-700 italic mb-6 text-lg" data-id="element-202">"{quote}"</p>
      <div className="border-t pt-4" data-id="element-203">
        <p className="font-bold text-gray-900" data-id="element-204">{name}</p>
        <p className="text-sm text-gray-600" data-id="element-205">{role}</p>
        <p className="text-xs text-gray-500" data-id="element-206">{location}</p>
      </div>
    </div>;
}